const withHomeHash = (href) => {
    if (!href?.startsWith('#')) return href
    return `/${href}`
}

export const homepageNav = [
    {
        title: 'Services',
        sectionTitle: 'Direct Mail Services',
        items: [
            {
                label: 'Managed Campaigns',
                href: '/services#managed-campaigns',
                description:
                    'Strategy, creative, list, production, and execution support',
            },
            {
                label: 'Mailing Lists & Data',
                href: '/services#mailing-lists-data',
                description:
                    'Targeted lists, data hygiene, segmentation, and campaign prep',
            },
            {
                label: 'Strategy & Creative',
                href: '/services#strategy-creative',
                description:
                    'Campaign planning, offer guidance, copy, design, and testing',
            },
            {
                label: 'Response Tracking',
                href: '/services#response-tracking',
                description: 'Call tracking numbers and QR code tracking',
            },
            {
                label: 'High-Volume Mailers',
                href: '/services#high-volume-programs',
                description:
                    'Annual agreements, committed volume, dedicated capacity',
            },
        ],
    },
    {
        title: 'Shop',
        sectionTitle: 'Mail Formats',
        items: [
            {
                label: 'Multi-Touch Campaigns',
                href: '/products#multi-touch-campaigns',
                description:
                    'Combine multiple mail formats into one coordinated campaign.',
                flyoutTitle: 'Multi-Touch Campaigns',
                flyoutItems: [
                    {
                        label: 'Create Your Own Campaign',
                        href: '/product/create-your-own-campaign',
                    },
                    {
                        label: 'Proven Mix Campaign',
                        href: '/product/proven-mix-campaigns',
                    },
                ],
            },
            {
                label: 'Real Penned Letters',
                href: '/products#real-penned-products',
                description:
                    'Written with real blue ink pens for a genuine handwritten look.',
                flyoutTitle: 'Real Penned Letters',
                flyoutItems: [
                    {
                        label: 'Real Penned Personal Letters',
                        href: '/product/real-penned-letters',
                    },
                    {
                        label: 'Real Penned Professional Letters',
                        href: '/product/real-penned-professional-letters',
                    },
                ],
            },
            {
                label: 'Postcards',
                href: '/product/postcards',
                description:
                    'Full-color postcards available in sizes from 4x6 to 9x12.',
            },
            {
                label: 'Printed Letters',
                href: '/products#letters',
                description: 'Professional and personal letter formats.',
                flyoutTitle: 'Printed Letters',
                flyoutItems: [
                    {
                        label: 'Personal Letters',
                        href: '/product/personal-letters',
                    },
                    {
                        label: 'Professional Letters',
                        href: '/product/professional-letters',
                    },
                ],
            },
            {
                label: 'Snap Packs',
                href: '/product/snap-pack-check-mailers-ros',
                description: 'Sealed-edge mailers built for high open rates',
            },
            {
                label: 'Tri-fold Flyers',
                href: '/product/tri-fold-flyers',
                description:
                    'Folded mailers that deliver more message without the barrier of an envelope.',
            },
        ],
    },
    {
        title: 'Platform',
        sectionTitle: 'Open Letter Connect',
        items: [
            {
                label: 'Features',
                href: '/platform/features',
                description:
                    'Build, launch, and track direct mail campaigns from one platform',
            },
            {
                label: 'Integrations',
                href: '/platform/integrations',
                description:
                    'Connect direct mail with your CRM and marketing stack',
            },
            {
                label: 'Use Cases',
                href: '/platform/use-cases',
                description:
                    'Explore workflows for real estate, home services, agencies, and more',
            },
            {
                label: 'API & SDK',
                href: '/platform/api-sdk',
                description:
                    'Embed direct mail sending, webhooks, and automation into your software',
            },
            {
                label: 'Pricing',
                href: '/platform/pricing',
                description: 'Platform pricing and plan options',
            },
            {
                label: 'Help Center',
                href: 'https://help.openletterconnect.com/olc-help-docs',
                description: 'Guides, docs, and support resources',
                external: true,
                support: true,
            },
            {
                label: 'Developer Docs',
                href: 'https://api-docs.openletterconnect.com/',
                description:
                    'API reference, SDKs, sandbox, and integration guides',
                external: true,
                support: true,
            },
        ],
    },
    {
        title: 'Industries',
        items: [
            {
                label: 'Dental',
                href: '/dental',
            },
            {
                label: 'HVAC',
                href: '/hvac',
            },
            {
                label: 'Insurance',
                href: '/insurance',
                hidden: true,
            },
            {
                label: 'Landscaping',
                href: '/landscaping',
            },
            {
                label: 'Plumbing',
                href: '/plumbing',
                hidden: true,
            },
            {
                label: 'Roofers',
                href: '/roofers',
            },
            {
                label: 'Real Estate Agents',
                href: '/real-estate-agents',
            },
            {
                label: 'Real Estate Investors',
                href: '/real-estate-investors',
            },
            {
                label: 'Other Industries',
                href: '/all-industry',
                separatorBefore: true,
                hidden: true,
            },
        ],
    },
    {
        title: 'Resources',
        items: [
            {
                label: 'Blog',
                href: '/blog',
                description: 'Direct mail strategy and execution insights',
            },
            {
                label: 'Reviews',
                href: '/reviews',
                description: 'See what customers are saying',
            },
            {
                label: 'Contact us',
                href: '/contact-us',
                description: 'Get in touch with our team',
            },
        ],
    },
]

export const trustPills = [
    {
        label: 'Ecommerce',
        icon: '🛒',
        badgeClass: 'bg-[#FEF9EC] text-[#BA7517]',
    },
    {
        label: 'Financial Services',
        icon: '💼',
        badgeClass: 'bg-[#EFF6FF] text-[#2563EB]',
    },
    {
        label: 'Home Services',
        icon: '🏠',
        badgeClass: 'bg-[#F0FDF4] text-[#16A34A]',
    },
    {
        label: 'Insurance',
        icon: '🛡️',
        badgeClass: 'bg-[#F5F0FE] text-[#7C3AED]',
    },
    {
        label: 'Real Estate',
        icon: '🏡',
        badgeClass: 'bg-[#FEF3EC] text-[#ED5C2F]',
    },
    {
        label: 'Retail',
        icon: '🏬',
        badgeClass: 'bg-[#FEFCE8] text-[#CA8A04]',
    },
]

export const fitCards = [
    {
        title: 'Already mailing?',
        description:
            'Improve campaign structure, audience quality, format testing, production speed, and execution consistency without starting from scratch.',
        icon: '📬',
        badgeClass: 'bg-[#FEF3EC] text-[#ED5C2F]',
    },
    {
        title: 'Ready to launch?',
        description:
            'Start with a smarter plan — audience, offer, creative, cadence, and budget — instead of guessing through your first few campaigns.',
        icon: '🚀',
        badgeClass: 'bg-[#FFF7ED] text-[#F28230]',
    },
    {
        title: 'Need automation?',
        description:
            'Use Open Letter Connect to trigger direct mail from your CRM, ecommerce platform, marketing workflows, or internal software.',
        icon: '⚙️',
        badgeClass: 'bg-[#FEFCE8] text-[#CA8A04]',
    },
]

export const managedCampaignBullets = [
    'Teams running active, recurring mail programs',
    'Companies launching with a serious budget',
    'Teams that want strategy plus execution',
]

export const managedCampaignSteps = [
    {
        number: '01',
        label: 'Strategy',
        title: 'Audience & targeting',
        tone: 'bg-[#ED5C2F]',
        kind: 'chips',
    },
    {
        number: '02',
        label: 'Creative',
        title: 'Copy, design & A/B test',
        tone: 'bg-[#F28230]',
        kind: 'thumbs',
    },
    {
        number: '03',
        label: 'Drop Mail',
        title: 'Print, mail & track',
        tone: 'bg-[#FAB331]',
        kind: 'live',
    },
    {
        number: '04',
        label: 'Performance',
        title: 'Response & ROI report',
        tone: 'bg-[#3F454F]',
        kind: 'chart',
    },
]

export const selfServeBullets = [
    'Quick orders and reorders',
    'Teams that already know what they want to mail',
    'Simple one-off sends and fast product ordering',
]

export const productFormats = [
    {
        name: 'Multi-Touch',
        badge: 'Popular',
        icon: '📋',
        href: '/products#multi-touch-campaigns',
        tone: 'bg-[#FEF3EC] text-[#ED5C2F]',
    },
    {
        name: 'Penned Letters',
        badge: 'Signature',
        icon: '✍️',
        href: '/products#real-penned-products',
        tone: 'bg-[#FFF0EB] text-[#F28230]',
    },
    {
        name: 'Postcards',
        icon: '📮',
        href: '/products#postcards',
        tone: 'bg-[#FFF7ED] text-[#F28230]',
    },
    {
        name: 'Printed Letters',
        icon: '📄',
        href: '/products#letters',
        tone: 'bg-[#F9F8F6] text-[#3F454F]',
    },
    {
        name: 'Snap Packs',
        icon: '📦',
        href: '/products#offer-products',
        tone: 'bg-[#F3F4F6] text-[#3F454F]',
    },
    {
        name: 'Self Mailers',
        icon: '📨',
        href: '/products#self-mailers',
        tone: 'bg-[#EFF6FF] text-[#2563EB]',
    },
]

export const olcBullets = [
    'CRM and marketing automation teams',
    'Ecommerce, SaaS, agencies, and enterprise teams',
    'Lifecycle, retention, win-back, and lead follow-up',
]

export const olcIntegrations = [
    {
        name: 'HighLevel',
        icon: 'G',
        badgeClass: 'bg-[#41B883]',
    },
    {
        name: 'Shopify',
        icon: 'S',
        badgeClass: 'bg-[#95BF47]',
    },
    {
        name: 'Zapier',
        icon: 'Z',
        badgeClass: 'bg-[#FF4F00]',
    },
    {
        name: 'HubSpot',
        icon: 'H',
        badgeClass: 'bg-[#FF7A59]',
    },
    {
        name: 'Print & Mail API',
        icon: 'API',
        badgeClass: 'bg-[#FAB331] text-[#1A1D23]',
    },
    {
        name: 'SDK',
        icon: 'SDK',
        badgeClass: 'bg-[#F28230]',
    },
]

export const footerColumns = [
    {
        title: 'Services',
        items: [
            {
                label: 'Managed Campaigns',
                href: 'https://try.openlettermarketing.com/services#2y4r6lkb',
                external: true,
            },
            {
                label: 'Mailing Lists & Data',
                href: 'https://try.openlettermarketing.com/services#lk6gsuev',
                external: true,
            },
            {
                label: 'Strategy & Creative',
                href: 'https://try.openlettermarketing.com/services#gr5c7nvt',
                external: true,
            },
            {
                label: 'Response Tracking',
                href: 'https://try.openlettermarketing.com/services#4gib3i75',
                external: true,
            },
            {
                label: 'High-Volume Programs',
                href: 'https://try.openlettermarketing.com/services#exljqvxe',
                external: true,
            },
            { label: 'Products', href: '/products' },
        ],
    },
    {
        title: 'Platform',
        items: [
            {
                label: 'Open Letter Connect',
                href: 'https://openletterconnect.com/',
                external: true,
            },
            {
                label: 'Integrations',
                href: 'https://openletterconnect.com/',
                external: true,
            },
            {
                label: 'API & SDK',
                href: 'https://api-docs.openletterconnect.com/',
                external: true,
            },
            {
                label: 'Pricing',
                href: 'https://openletterconnect.com/pricing/',
                external: true,
                hidden: true,
            },
            {
                label: 'Developer Docs',
                href: 'https://api-docs.openletterconnect.com/',
                external: true,
            },
        ],
    },
    {
        title: 'Resources',
        items: [
            { label: 'Case Studies', href: '/reviews' },
            { label: 'Blog', href: '/blog' },
            {
                label: 'Platform Help Center',
                href: 'https://help.openletterconnect.com/olc-help-docs',
                external: true,
            },
            { label: 'Reviews', href: '/reviews' },
        ],
    },
    {
        title: 'Company',
        items: [
            { label: 'About', href: '/about', hidden: true },
            {
                label: 'Industries',
                href: '#industries',
                globalHref: withHomeHash('#industries'),
            },
            { label: 'Contact', href: '/contact-us' },
            { label: 'Book a Call', action: 'bookCall' },
        ],
    },
]
